import i18n from 'i18next';
import Cookies from 'js-cookie';
import { useEffect } from 'react';

type Props = { children: React.ReactNode };

export default function LangSettings({ children }: Props) {
    const lng = Cookies.get('i18next') || 'ar';
    useEffect(() => {
        window.document.dir = i18n.dir();
    }, [lng]);
    return <>{children}</>;
}
